import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";

import * as forge from "@tylertech/forge";
forge.defineButtonComponent();

import { SimpleAlertDialogComponent, ShellService } from "./services";

const angularMaterialModules = [
    MatDialogModule
];
@NgModule({
    imports: [
        ...angularMaterialModules,
    ],
    declarations: [SimpleAlertDialogComponent],
    providers: [ShellService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class IncodeModule { }
